<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <!-- Would you like to delete? -->
    {{data.message}}
</mat-dialog-content>
<mat-dialog-actions style="margin: 0 5px 0 5px;gap :5px">
    <button matButton class="dialog-no-btn" (click)="onCancel()">No</button>
    <button matButton class="dialog-ok-btn" color="primary" (click)="onOk()">Ok</button>
</mat-dialog-actions>